module.exports = __webpack_public_path__ + "static/img/functionTitle.7352627b.png";